import { createRouter, createWebHashHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

const routes = [
  {
    path: '/',
    name: '時大音樂 APP 後台',
    component: DefaultLayout,
    // redirect: '/leaderboard/7101',
    children: [
      //樂易捐
      {
        path: '/cheerfulGive',
        name: 'Cheerful Give 樂易捐連結',
        beforeEnter() {
          console.log(process.env.NODE_ENV, 'routes')
          if (process.env.NODE_ENV === 'production') {
            window.open(
              'https://admin.cheerfulgive.to/#/common/login',
              '_blank',
            )
          } else {
            window.open(
              'https://dona2-admin.luciditv.net/#/common/login',
              '_blank',
            )
          }
        },
      },

      //7101
      // {
      //   path: '/leaderboard/7101',
      //   name: '7101 - 排行榜一覽',
      //   component: () => import('@/views/leaderboard/7101.vue'),
      // },

      //7102
      // {
      //   path: '/leaderboard/7102',
      //   name: '7102 - 排行榜查詢',
      //   component: () => import('@/views/leaderboard/7102.vue'),
      // },

      //4101
      {
        path: '/musicStorge/4101',
        name: '4101 - 創作者管理',
        component: () => import('@/views/musicStorge/4101.vue'),
      },

      //4101->新增創作者
      {
        path: '/musicStorge/4101AddMlArtist',
        name: '4101 - 新增 創作者',
        component: () => import('@/views/musicStorge/4101AddMlArtist.vue'),
      },

      //4101->編輯創作者
      {
        path: '/musicStorge/4101EditMlArtist/:id',
        name: '4101 - 編輯 創作者',
        component: () => import('@/views/musicStorge/4101EditMlArtist.vue'),
      },

      //4102
      {
        path: '/musicStorge/4102',
        name: '4102 - 歌曲管理',
        component: () => import('@/views/musicStorge/4102.vue'),
      },

      //4102->新增歌曲
      {
        path: '/musicStorge/4102AddMlSong',
        name: '4102 - 新增 歌曲',
        component: () => import('@/views/musicStorge/4102AddMlSong.vue'),
      },

      //4102->編輯歌曲
      {
        path: '/musicStorge/4102EditMlSong/:id',
        name: '4102 - 編輯 歌曲',
        component: () => import('@/views/musicStorge/4102EditMlSong.vue'),
      },

      //4104
      {
        path: '/musicStorge/4104',
        name: '4104 - 歌單/專輯管理',
        component: () => import('@/views/musicStorge/4104.vue'),
      },

      //4104->新增 歌單/專輯
      {
        path: '/musicStorge/4104AddMlPlaylist',
        name: '4104 - 新增 歌單/專輯',
        component: () => import('@/views/musicStorge/4104AddMlPlaylist.vue'),
      },

      //4104->編輯 歌單/專輯
      {
        path: '/musicStorge/4104EditMlPlaylist/:id',
        name: '4104 - 編輯 歌單/專輯',
        component: () => import('@/views/musicStorge/4104EditMlPlaylist.vue'),
      },

      //5101 輪播公告
      {
        path: '/homePage/5101',
        name: '5101 - 輪播公告管理',
        component: () => import('@/views/homePage/5101.vue'),
      },

      //5101->新增輪播公告
      {
        path: '/homePage/5101AddApBulletin',
        name: '5101 - 新增 輪播公告',
        component: () => import('@/views/homePage/5101AddApBulletin.vue'),
      },

      //5101->編輯輪播公告
      {
        path: '/homePage/5101EditApBulletin/:id',
        name: '5101 - 編輯 輪播公告',
        component: () => import('@/views/homePage/5101EditApBulletin.vue'),
      },

      //5102
      {
        path: '/homePage/5102',
        name: '5102 - STAR 精選管理',
        component: () => import('@/views/homePage/5102.vue'),
      },

      //5102->新增 歌單/專輯
      {
        path: '/homePage/5102AddStarFeatured',
        name: '5102 - 新增 歌單/專輯',
        component: () => import('@/views/homePage/5102AddStarFeatured.vue'),
      },

      //5102->編輯 歌單/專輯
      {
        path: '/homePage/5102EditStarFeatured/:id',
        name: '5102 - 編輯 歌單/專輯',
        component: () => import('@/views/homePage/5102EditStarFeatured.vue'),
      },

      //5103
      {
        path: '/homePage/5103',
        name: '5103 - 自定區塊管理',
        component: () => import('@/views/homePage/5103.vue'),
      },

      //5103->新增自定區塊
      {
        path: '/homePage/5103AddCustomBlock',
        name: '5103 - 新增 自定區塊',
        component: () => import('@/views/homePage/5103AddCustomBlock.vue'),
      },

      //5103->編輯自定區塊
      {
        path: '/homePage/5103EditCustomBlock/:id',
        name: '5103 - 編輯 自定區塊',
        component: () => import('@/views/homePage/5103EditCustomBlock.vue'),
      },

      //5104
      {
        path: '/homePage/5104',
        name: '5104 - 訊息通知管理',
        component: () => import('@/views/homePage/5104.vue'),
      },

      //5104->查看 訊息通知
      {
        path: '/homePage/5104ShowApNotice/:id',
        name: '5104 - 查看 訊息通知',
        component: () => import('@/views/homePage/5104ShowApNotice.vue'),
      },

      //5104->新增 訊息通知
      {
        path: '/homePage/5104AddApNotice',
        name: '5104 - 新增 訊息通知',
        component: () => import('@/views/homePage/5104AddApNotice.vue'),
      },

      //5104->編輯 訊息通知
      {
        path: '/homePage/5104EditApNotice/:id',
        name: '5104 - 編輯 訊息通知',
        component: () => import('@/views/homePage/5104EditApNotice.vue'),
      },

      //6101
      {
        path: '/mv/6101',
        name: '6101 - MV區塊管理',
        component: () => import('@/views/mv/6101.vue'),
      },

      //6101->新增 MV區塊
      {
        path: '/mv/6101AddMVPlaylist',
        name: '6101 - 新增 MV區塊',
        component: () => import('@/views/mv/6101AddMVPlaylist.vue'),
      },

      //6101->編輯 MV區塊
      {
        path: '/mv/6101EditMVPlaylist/:id',
        name: '6101 - 編輯 MV區塊',
        component: () => import('@/views/mv/6101EditMVPlaylist.vue'),
      },

      //6101->新增 MV
      {
        path: '/mv/6101AddMV',
        name: '6101 - 新增 MV',
        component: () => import('@/views/mv/6101AddMV.vue'),
      },

      //6101->編輯 MV
      {
        path: '/mv/6101EditMV/:id',
        name: '6101 - 編輯 MV',
        component: () => import('@/views/mv/6101EditMV.vue'),
      },

      //3101
      {
        path: '/memberCard/3101',
        name: '3101 - 會員管理',
        component: () => import('@/views/memberCard/3101.vue'),
      },

      //3101->會員訂閱記錄
      {
        path: '/memberCard/3101ShowMemberInfo/:id',
        name: '3101 - 會員訂閱記錄',
        component: () => import('@/views/memberCard/3101ShowMemberInfo.vue'),
      },

      //3101->iOS 訂單記錄
      {
        path: '/memberCard/3101ShowIosReceipts/:id',
        name: '3101 - iOS 訂單記錄',
        component: () => import('@/views/memberCard/3101ShowIosReceipts.vue'),
      },

      //3101->Android 訂單記錄
      {
        path: '/memberCard/3101ShowAndroidReceipts/:id',
        name: '3101 - Android 訂單記錄',
        component: () =>
          import('@/views/memberCard/3101ShowAndroidReceipts.vue'),
      },

       //3102
       {
        path: '/memberCard/3102',
        name: '3102 - 商店收據查詢',
        component: () => import('@/views/memberCard/3102.vue'),
      },

      //3103
      {
        path: '/memberCard/3103',
        name: '3103 - 心禮卡管理',
        component: () => import('@/views/memberCard/3103.vue'),
      },

      //1101
      {
        path: '/userMgt/1101',
        name: '1101 - 使用者帳號管理',
        component: () => import('@/views/userMgt/1101.vue'),
      },

      //1101->編輯 使用者帳號
      {
        path: '/userMgt/1101EditScUser/:id',
        name: '1101 - 編輯 使用者帳號',
        component: () => import('@/views/userMgt/1101EditScUser.vue'),
      },
    ],
  },

  {
    path: '/loginPages',
    redirect: '/loginPages/404',
    name: 'LoginPages',
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/loginPages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/loginPages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/loginPages/Login'),
      },
      {
        path: 'finishLogin',
        name: 'FinishLogin',
        component: () => import('@/views/loginPages/FinishLogin'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})
router.beforeEach((to) => {
  const user = firebase.auth().currentUser

  if (user || to.name == 'Login') {
    return true
  } else {
    return { name: 'Login' }
  }
})

export default router
